// frontend/src/services/shopService.js
import api from './api';

// ============================================
// SHOP ADMIN SERVICE
// Онлайн шопын админы API функцүүд
// ============================================

/**
 * Dashboard статистик авах
 * GET /api/v1/shop/stats
 */
export const getShopStats = async () => {
  try {
    const response = await api.get('/shop/stats');
    return response.data;
  } catch (error) {
    console.error('❌ getShopStats error:', error);
    throw error;
  }
};

/**
 * Хүргэлт үүсгэх
 * POST /api/v1/shop/deliveries
 */
export const createDelivery = async (data) => {
  try {
    const response = await api.post('/shop/deliveries', data);
    return response.data;
  } catch (error) {
    console.error('❌ createDelivery error:', error);
    throw error;
  }
};

/**
 * Хүргэлтүүдийн жагсаалт авах (filters, pagination)
 * GET /api/v1/shop/deliveries
 */
export const getDeliveries = async (params = {}) => {
  try {
    const response = await api.get('/shop/deliveries', { params });
    return response.data;
  } catch (error) {
    console.error('❌ getDeliveries error:', error);
    throw error;
  }
};

/**
 * Хүргэлтийн дэлгэрэнгүй мэдээлэл авах
 * GET /api/v1/shop/deliveries/:id
 */
export const getDeliveryDetail = async (id) => {
  try {
    const response = await api.get(`/shop/deliveries/${id}`);
    return response.data;
  } catch (error) {
    console.error('❌ getDeliveryDetail error:', error);
    throw error;
  }
};

/**
 * Барааны жагсаалт авах
 * GET /api/v1/shop/products
 */
export const getProducts = async (params = {}) => {
  try {
    const response = await api.get('/shop/products', { params });
    return response.data;
  } catch (error) {
    console.error('❌ getProducts error:', error);
    throw error;
  }
};

/**
 * Дүүргүүдийн жагсаалт авах
 * GET /api/v1/districts
 */
export const getDistricts = async () => {
  try {
    const response = await api.get('/districts');
    return response.data;
  } catch (error) {
    console.error('❌ getDistricts error:', error);
    throw error;
  }
};

/**
 * Хүргэлтийн статус шинэчлэх (optional - дараа нэмэх)
 * PATCH /api/v1/shop/deliveries/:id/status
 */
export const updateDeliveryStatus = async (id, status) => {
  try {
    const response = await api.patch(`/shop/deliveries/${id}/status`, { status });
    return response.data;
  } catch (error) {
    console.error('❌ updateDeliveryStatus error:', error);
    throw error;
  }
};

/**
 * Хүргэлт устгах (optional - дараа нэмэх)
 * DELETE /api/v1/shop/deliveries/:id
 */
export const deleteDelivery = async (id) => {
  try {
    const response = await api.delete(`/shop/deliveries/${id}`);
    return response.data;
  } catch (error) {
    console.error('❌ deleteDelivery error:', error);
    throw error;
  }
};